import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    StorageItemId} from "../storage-items/storage-item-id";
import {
    storageItemIdZodSchema,
} from "../storage-items/storage-item-id";
import type { ResourceMapId} from "./resource-map-id";
import { resourceMapIdZodSchema } from "./resource-map-id";

type ResourceMapEditCommand = {
    readonly _id: string;
    readonly _type: "RESOURCE_MAP_EDIT_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly data: {
        _id: ResourceMapId;
        title: string;
        storageItemId: StorageItemId;
    };
};

type FactoryParams = Except<
    ResourceMapEditCommand,
    "_id" | "_type" | "_createdAt"
>;
const resourceMapEditCommandFactory = (params: FactoryParams) => {
    const ResourceMapEditCommand: ResourceMapEditCommand = {
        ...params,
        _id: generateId({ prefix: "resource_add_command__" }),
        _type: "RESOURCE_MAP_EDIT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return ResourceMapEditCommand;
};

const resourceMapEditCommandZodSchema: z.ZodSchema<ResourceMapEditCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("RESOURCE_MAP_EDIT_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        data: z.object({
            _id: resourceMapIdZodSchema,
            title: z.string().min(1),
            storageItemId: storageItemIdZodSchema,
        }),
    });

export { resourceMapEditCommandFactory, resourceMapEditCommandZodSchema };
export type {
    ResourceMapEditCommand,
    FactoryParams as ResourceMapEditCommandFactoryParams,
};
